import { get, post } from "@/utils/request";
import type { Recall, CommonForm, Detail } from "@/types/procss";
import type { Response } from "@/types/axios";

//节点3开始
//核名
export const checkNameDetail = (params: {
  Id: number | string;
}): Promise<Response<Detail>> => post("/api/checkName/checkNameDetail", params);

//提交
export const submitCheckNameApply = (params: Detail) =>
  post("/api/checkName/submitCheckNameApply", params);

//更新
export const editCheckNameApply = (params: Detail) => {
  return post("/api/checkName/editCheckNameApply", params);
};
//撤回
export const recallCheckNameApply = (params: Recall) => {
  return post("/api/checkName/recallCheckNameApply", params);
};

// 获取公司帐号详情
export const companyAccountDetail = (params: {
  Id: number | string;
}): Promise<Response<Detail>> =>
  post("/api/companyAccount/companyAccountDetail", params);

//提交
export const submitCompanyAccountApply = (params: Detail) =>
  post("/api/companyAccount/submitCompanyAccountApply", params);

//更新
export const editCompanyAccountApply = (params: Detail) => {
  return post("/api/companyAccount/editCompanyAccountApply", params);
};
//撤回
export const recallCompanyAccountApply = (params: Recall) => {
  return post("/api/companyAccount/recallCompanyAccountApply", params);
};
